export const defaultIntelFormData = {
    // 模式
    composition: {
        // 组合（背景替换）：combination
        // 纯背景（图片生成）：background
        // 仅主体：mainBody
        type: 'background',
        value: {
            // 居中：center
            // 居左：left
            // 居右：right
            // 居上：top
            // 居下：bottom
            position: 'bottom', // 默认居下
            // 偏小：small
            // 标准：middle
            // 偏大: large
            size: 2
        }
    },
    // 尺寸
    sizeControl: {
        // 选择：choose
        // 自定义：'custom'
        type: 'choose',
        value: {
            ratio: '16:9',
            dimension: '1140*640',
            customWidth: '',
            customHeight: ''
        }
    },
    // 尺寸
    sizeControlBg: {
        // 选择：choose
        // 自定义：'custom'
        type: 'choose',
        value: {
            ratio: '16:9',
            dimension: '1140*640',
            customWidth: '',
            customHeight: ''
        }
    },
    // 主体
    mainPart: {
        // 智能生成： generate
        // 选择预设： choose
        // 自定义： custom
        type: 'generate',
        value: {
            prompt: '',
            chooseList: [],
            uploadList: []
        }
    },
    // 组合模式的主体
    mainPartCombine: {
        // 智能生成： generate
        // 选择预设： choose
        // 自定义： custom
        type: 'custom',
        value: {
            prompt: '',
            chooseList: [],
            uploadList: []
        }
    },
    // 背景【背景+主体tab】
    bgControlCom: {
        type: 'bgStyle',
        value: {
            bgStyle: '简约空间',
            colorList: []
        }
    },
    // 背景【背景tab】
    bgControlBg: {
        type: 'generate',
        value: {
            bgStyle: '几何空间',
            colorList: [],
            prompt: ''
        }
    }
    // 背景风格
    // bgStyle: {
    //     switch: false,
    //     value: '真实场景'
    // }
};

export const defaultDesignFormData = {
    // 底图
    bgBase: {
        // 上传： upload
        // 带入：quickUse
        type: 'quickUse',
        value: {
            onlySubject: false,
            uploadUrl: [],
            uploadMainUrl: [],
            bringComposition: '',
            bringCombination: {},
            bringUrlList: []
        }
    },
    // 行业
    industry: {
        value: ''
    },
    // 尺寸
    sizeControl: {
        // 选择：choose
        // 自定义：custom
        type: 'choose',
        value: {
            ratio: '16:9',
            dimension: '1140*640',
            customWidth: '',
            customHeight: ''
        }
    },
    // 模版
    templateDesign: {
        switch: true,
        // 智能设计：intelligent
        // 选择模版：choose
        type: 'choose',
        value: {
            chooseList: []
        }
    },
    // 文案控件
    writing: {
        switch: true
    },
    // 主标题
    mainText: {
        value: ''
    },
    // 副标题
    descText: {
        value: ''
    },
    // 按钮文案
    buttonText: {
        value: ''
    },
    // 其他文案
    otherText: {
        value: ''
    },
    // 品牌文案
    brandText: {
        value: ''
    },
    // 业务点
    businessPointB2B: {
        value: ''
    },
    // 卖点1
    sellingPointFirst: {
        value: ''
    },
    // 卖点2
    sellingPointSecond: {
        value: ''
    },
    // 卖点3
    sellingPointThird: {
        value: ''
    },
    // 厂商名称
    manufacturerName: {
        value: ''
    }
};
